// Defining the state data here
export default {
    resources: {},
};
